// Mock data for 306 Garage Doors

export const businessInfo = {
  name: "306 Garage Doors",
  tagline: "Saskatoon's Most Trusted Garage Door Experts",
  phone: "306-262-5995",
  email: "garagedoors306@gmail.com",
  availability: "24/7 Emergency Service Available",
  address: "1118 Hilders Crescent, Saskatoon, SK S7L 6T9",
  serviceArea: "Serving Saskatoon & Surrounding Areas",
  confidentialMessage: "Your information is 100% confidential and never shared"
};

export const services = [
  {
    id: 1,
    title: "Garage Door Installation",
    description: "Professional installation of new residential and commercial garage doors with warranty.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Garage Door Repair",
    description: "Fast and reliable repair services for all makes and models of garage doors.",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Opener Installation & Repair",
    description: "Expert installation and repair of garage door openers from leading brands.",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Spring Replacement",
    description: "Safe and efficient replacement of broken or worn garage door springs.",
    icon: "RefreshCw"
  },
  {
    id: 5,
    title: "Preventive Maintenance",
    description: "Regular maintenance services to keep your garage door operating smoothly.",
    icon: "CheckCircle"
  },
  {
    id: 6,
    title: "Emergency Services",
    description: "24/7 emergency repair services when you need us most.",
    icon: "AlertCircle"
  },
  {
    id: 7,
    title: "Cable Repair & Replacement",
    description: "Professional cable repair and replacement to ensure safe door operation.",
    icon: "Anchor"
  },
  {
    id: 8,
    title: "Panel Replacement",
    description: "Replace damaged panels to restore your door's appearance and function.",
    icon: "Square"
  },
  {
    id: 9,
    title: "Track Alignment",
    description: "Precision track alignment for smooth and quiet door operation.",
    icon: "AlignJustify"
  },
  {
    id: 10,
    title: "Weatherstripping",
    description: "Seal your garage from the elements with quality weatherstripping.",
    icon: "Wind"
  },
  {
    id: 11,
    title: "Safety Inspections",
    description: "Comprehensive safety inspections to ensure your door meets all standards.",
    icon: "ShieldCheck"
  },
  {
    id: 12,
    title: "Commercial Services",
    description: "Specialized services for commercial and industrial garage doors.",
    icon: "Building"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Regina, SK",
    rating: 5,
    text: "Excellent service! They came out within hours of my call and fixed my garage door spring. Very professional and reasonably priced.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Mike Thompson",
    location: "Saskatoon, SK",
    rating: 5,
    text: "I've used 306 Garage Doors twice now - once for installation and once for repair. Both times they exceeded expectations. Highly recommend!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jennifer Lee",
    location: "Moose Jaw, SK",
    rating: 5,
    text: "Fast, reliable, and trustworthy. They diagnosed the problem quickly and had the parts on hand. My door works perfectly now!",
    date: "3 weeks ago"
  }
];

export const whyChooseUs = [
  {
    title: "Premium Quality Products",
    description: "We use only the best garage door brands and materials"
  },
  {
    title: "24/7 Emergency Service",
    description: "We're here when you need us, day or night"
  },
  {
    title: "Licensed & Insured",
    description: "Fully certified professionals you can trust"
  },
  {
    title: "Upfront Pricing",
    description: "No hidden fees - transparent quotes every time"
  },
  {
    title: "Expert Workmanship",
    description: "Professional installation and repair every time"
  },
  {
    title: "Satisfaction Guaranteed",
    description: "Your satisfaction is our top priority"
  }
];

export const faqData = [
  {
    question: "How quickly can you respond to emergency calls?",
    answer: "We offer 24/7 emergency service and typically respond within 1-2 hours depending on your location."
  },
  {
    question: "Do you provide free estimates?",
    answer: "Yes! We provide free, no-obligation quotes for all services. Contact us today to schedule your estimate."
  },
  {
    question: "What brands do you work with?",
    answer: "We work with all major garage door brands including Clopay, Amarr, Wayne Dalton, and more. We service all makes and models."
  },
  {
    question: "How often should I have my garage door serviced?",
    answer: "We recommend annual maintenance to keep your garage door operating safely and efficiently."
  },
  {
    question: "Do you offer warranties on your work?",
    answer: "Yes, all our installations and repairs come with warranties on both parts and labor for your peace of mind."
  }
];
